import { render } from "./calssList.vue?vue&type=template&id=86e5af7c&scoped=true"
import script from "./calssList.vue?vue&type=script&lang=js"
export * from "./calssList.vue?vue&type=script&lang=js"

import "./calssList.vue?vue&type=style&index=0&id=86e5af7c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e5af7c"]])

export default __exports__